import axios from "axios";
import { Payout_Service } from '../Url';



export const partnerPayoutListByFyAction = {
  PARTNER_PAYOUT_LIST_BY_FY_SUCCESS: "PARTNER_PAYOUT_LIST_BY_FY_SUCCESS",
  PARTNER_PAYOUT_LIST_BY_FY_ERROR: "PARTNER_PAYOUT_LIST_BY_FY_ERROR",
};

export function partnerPayoutListByFy(props) {
  const { accessToken, partnerid, financialYear, approvalStageId } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url:`http://localhost:8301/partner-payout-service/reports/get/monthly/partnerSummary?partnerId=${partnerid}&year=${financialYear}&approvalStageId=${approvalStageId}`
        url: `${Payout_Service}/reports/get/monthly/partnerSummary?partnerId=${partnerid}&year=${financialYear}&approvalStageId=${approvalStageId}`,
      });
      const data = response.data;
      dispatch({
        type: partnerPayoutListByFyAction.PARTNER_PAYOUT_LIST_BY_FY_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: partnerPayoutListByFyAction.PARTNER_PAYOUT_LIST_BY_FY_ERROR,
        payload: error.message || "Failed to fetch partner payout list by FY",
      });
      return error;
    }
  };
}

export function fatechRemarkpratner(props) {
  const { accessToken, remarkdata } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/get/remarksByTypes`,
        data: remarkdata
      });
      const data = response.data;
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      return error;
    }
  };
}